import {
  InfrastructureProjectsApi,
  InfrastructureInstanceCreationRequest,
} from 'osep-generator-service-client-v1';
import { useApiConfig } from '../useApiConfig';

function useCreateInfraInstanceMutation() {
  const { getApiConfig, axiosInstance } = useApiConfig();

  const createInfraInstance = async (
    projectId: string,
    templateName: string,
    instance: InfrastructureInstanceCreationRequest,
  ) => {
    const config = await getApiConfig();
    const infraApi = new InfrastructureProjectsApi(
      config,
      undefined,
      axiosInstance,
    );

    const response = await infraApi.createInfrastructureInstance(
      projectId,
      templateName,
      instance,
    );

    return response.data;
  };

  return { createInfraInstance };
}

export default useCreateInfraInstanceMutation;
